/**
 * VaidGram brand mark — Rounded seal with the "SAMVAD" wordmark curved
 * clearly along the top, interlocking rings in the centre (bond), and a
 * small gold leaf accent. Scales cleanly at all sizes.
 */
export default function BrandMark({ size = 40, className = "" }) {
  const uid = "ayur-brand-" + Math.random().toString(36).slice(2, 8);
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      aria-label="VaidGram seal"
      role="img"
    >
      <defs>
        {/* Arc for the VAIDGRAM wordmark, high up so letters read clearly */}
        <path id={`${uid}-arc`} d="M 22 60 A 38 38 0 0 1 98 60" fill="none" />
        {/* Mask so ring A appears to thread through ring B */}
        <mask id={`${uid}-mask`}>
          <rect width="120" height="120" fill="white" />
          <path
            d="M52 74 A 12 12 0 0 1 64 82"
            stroke="black"
            strokeWidth="8"
            fill="none"
          />
        </mask>
      </defs>

      {/* Emerald filled disc */}
      <circle cx="60" cy="60" r="56" fill="currentColor" />
      {/* Cream hairline inner ring */}
      <circle cx="60" cy="60" r="50" fill="none" stroke="var(--ayur-cream, #FBF9F4)" strokeOpacity="0.35" strokeWidth="1" />

      {/* VAIDGRAM curved wordmark (top) */}
      <text
        fontFamily="'Fraunces', Georgia, serif"
        fontSize="13"
        fontWeight="700"
        letterSpacing="3.5"
        fill="var(--ayur-gold, #D4A359)"
      >
        <textPath href={`#${uid}-arc`} startOffset="50%" textAnchor="middle">
          VAIDGRAM
        </textPath>
      </text>

      {/* Small dots either side of the leaf */}
      <circle cx="30" cy="82" r="1.6" fill="var(--ayur-gold, #D4A359)" />
      <circle cx="90" cy="82" r="1.6" fill="var(--ayur-gold, #D4A359)" />

      {/* Two interlocking rings — the bond */}
      <g stroke="var(--ayur-cream, #FBF9F4)" strokeWidth="3.2" fill="none" strokeLinecap="round">
        <circle cx="52" cy="82" r="12" />
        <circle cx="68" cy="82" r="12" mask={`url(#${uid}-mask)`} />
      </g>

      {/* Gold leaf sprig above the rings */}
      <path
        d="M60 46 C 55 50, 55 58, 60 62 C 65 58, 65 50, 60 46 Z"
        fill="var(--ayur-gold, #D4A359)"
      />
      <line x1="60" y1="62" x2="60" y2="68" stroke="var(--ayur-gold, #D4A359)" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
